import React, { useState } from 'react';

import { Button } from '../../components/ui/button';

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';

import { Checkbox } from '../../components/ui/checkbox';

import { Calculator, Building } from 'lucide-react';

export const AssignDispositifsDialog = ({ open, onOpenChange, dispositifs, selectedCount, onAssign }) => {
  const [selected, setSelected] = useState([]);
  
  const toggleDispositif = (id) => {
    if (selected.includes(id)) {
      setSelected(selected.filter(d => d !== id));
    } else {
      setSelected([...selected, id]);
    }
  };
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Building className="h-5 w-5" />
            Assigner aux dispositifs
          </DialogTitle>
          <DialogDescription>
            {selectedCount} nomenclature(s) sélectionnée(s)
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4 space-y-2 max-h-[300px] overflow-y-auto">
          {dispositifs.length === 0 ? (
            <p className="text-sm text-slate-500 text-center py-4">Aucun dispositif disponible</p>
          ) : dispositifs.map(d => (
            <div 
              key={d.id} 
              className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
                selected.includes(d.id) ? 'border-indigo-500 bg-indigo-50' : 'border-slate-200 hover:bg-slate-50'
              }`}
              onClick={() => toggleDispositif(d.id)}
            >
              <Checkbox checked={selected.includes(d.id)} />
              <div>
                <p className="font-medium">{d.nom || d.name}</p>
                {d.description && <p className="text-sm text-slate-500">{d.description}</p>}
              </div>
            </div>
          ))}
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button onClick={() => { onAssign(selected); setSelected([]); }} disabled={selected.length === 0}>
            Assigner ({selected.length})
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

// Composant Dialog pour assignation d'estimateurs en masse
export const AssignEstimateursDialog = ({ open, onOpenChange, estimateurs, selectedCount, onAssign }) => {
  const [selected, setSelected] = useState([]);
  
  const toggleEstimateur = (id) => {
    if (selected.includes(id)) {
      setSelected(selected.filter(e => e !== id));
    } else {
      setSelected([...selected, id]);
    }
  };
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Calculator className="h-5 w-5" />
            Assigner aux estimateurs
          </DialogTitle>
          <DialogDescription>
            {selectedCount} nomenclature(s) sélectionnée(s)
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4 space-y-2 max-h-[300px] overflow-y-auto">
          {estimateurs.map(e => (
            <div 
              key={e.id} 
              className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
                selected.includes(e.id) ? 'border-indigo-500 bg-indigo-50' : 'border-slate-200 hover:bg-slate-50'
              }`}
              onClick={() => toggleEstimateur(e.id)}
            >
              <Checkbox checked={selected.includes(e.id)} />
              <div>
                <p className="font-medium">{e.name}</p>
                {e.description && <p className="text-sm text-slate-500">{e.description}</p>}
              </div>
            </div>
          ))}
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button onClick={() => { onAssign(selected); setSelected([]); }} disabled={selected.length === 0}>
            Assigner ({selected.length})
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
